import { useEffect, useState } from "react";
import LobbyPreviewShell from "./LobbyPreviewShell";
import { openLobbyPreviewChannel, type LobbyPreviewBundle } from "./lobbyPreviewBus";

// The same-browser live preview window (ADR 0134) at /caves/:caveId/lobby/preview.
// Opened by the editor via window.open; it renders purely from the editor's
// BroadcastChannel bundle (no auth boot, no fetching of its own — the editor did
// that), hydrating from the last localStorage snapshot on cold open and asking the
// editor to re-send with a "hello".

export default function LobbyPreviewScreen({ caveId, mode }: { caveId: string; mode: "desktop" | "phone" }) {
  const [bundle, setBundle] = useState<LobbyPreviewBundle | null>(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const chan = openLobbyPreviewChannel(caveId);
    // Cold-open hydration: show the last persisted state immediately.
    const snap = chan.snapshot();
    if (snap) setBundle(snap);
    const off = chan.onMessage((m) => {
      if (m.type === "state") {
        setBundle(m.bundle);
        setConnected(true);
      }
    });
    // Ask the (possibly already-open) editor to push the current bundle.
    chan.hello();
    // The editor may open this window slightly before it starts broadcasting;
    // re-ask a couple of times so we converge quickly.
    const retries = [200, 600].map((ms) => window.setTimeout(() => chan.hello(), ms));
    return () => {
      retries.forEach((t) => window.clearTimeout(t));
      off();
      chan.close();
    };
  }, [caveId]);

  return (
    <LobbyPreviewShell
      bundle={bundle}
      mode={mode}
      connected={connected}
      statusLabel="this browser"
      waitingNote="Keep the Designer open in its tab — this window mirrors it live as you edit."
    />
  );
}
